// extracted by mini-css-extract-plugin
export default {"logIn":"zLbGnsmInjpZpS990qQT","freeTicketPrize":"mimKoS5z6tGYdcT920Uq"};